import React from "react";
import { Field } from "react-final-form";
import { useSelector } from "react-redux";
import switchCondition from "./switchCondition";

const Condition = ({
  when,
  is,
  operator = "===",
  children,
  array,
  property,
  formApi,
  isInlineModal = false,
  modal,
}) => {
  const { stateAEWRS, stateAEWRHerderMonthly } = useSelector(
    (state) => state.referenceReducer
  );

  if (operator === "customValidation") {
    return (
      <Field name={is} subscription={{ value: true }}>
        {switchCondition(
          when,
          is,
          operator,
          children,
          formApi,
          property,
          array,
          isInlineModal,
          modal,
          {
            stateAEWRS,
            stateAEWRHerderMonthly,
          }
        )}
      </Field>
    );
  } else if (when !== undefined && is !== undefined) {
    return (
      <Field name={when} subscription={{ value: true }}>
        {switchCondition(
          when,
          is,
          operator,
          children,
          formApi,
          property,
          array,
          isInlineModal,
          modal,
          {
            stateAEWRS,
            stateAEWRHerderMonthly,
          }
        )}
      </Field>
    );
  }
  return children;
};

export default Condition;
